module.exports = __webpack_public_path__ + "img/illust-404@3x.6167e32.png";